import React from 'react'
import { Icon } from '.'

const PhoneListIcon = (props: any) => {
  return <span {...props} role="img" aria-label="phone" tabIndex={-1} className="anticon anticon-phone ml10 text-primary fs18"><Icon size={18} name="phone-list" /></span>
}

export default PhoneListIcon
